export const gamifiedResponseStoreKey = 'gamifiedResponse';
